import { Component, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ReplaySubject } from 'rxjs';
import * as fromDataServices from '../../data-services';
import { ITask } from '../../lookups';

@Component({
    selector: 'ef-merge-presenter',
    templateUrl: './merge-presenter.component.html',
    styleUrls: ['./merge-presenter.component.scss'],
    standalone: false
})
export class MergePresenterComponent implements OnInit {
    types: SelectItem[];
    selectedType: any;
    selectedItemFrom: any;
    selectedItemFinal: any;

    typeItems: SelectItem[];

    @Output() Merge = new ReplaySubject<any>(1);

    IsSuccess: boolean;
    ShowStatus = false;
    areYouSure = false;

    private TasksSubject = new ReplaySubject<Array<SelectItem>>(1);
    private _tasks: Array<SelectItem>;
    @Input() set tasks(value: Array<SelectItem>) {
        this._tasks = value;
        this.TasksSubject.next(value);
    }
    get tasks(): Array<SelectItem> {
        return this._tasks;
    }

    private ServiceItemsSubject = new ReplaySubject<Array<SelectItem>>(1);
    private _serviceitems: Array<SelectItem>;
    @Input() set serviceItems(value: Array<SelectItem>) {
        this._serviceitems = value;
        this.ServiceItemsSubject.next(value);
    }
    get serviceItems(): Array<SelectItem> {
        return this._serviceitems;
    }

    private MergeSubject = new ReplaySubject<Array<fromDataServices.Merge.Merge>>(1);
    private _merge: Array<fromDataServices.Merge.Merge>;
    @Input() set merge(value: Array<fromDataServices.Merge.Merge>) {
        this._merge = value;
        this.MergeSubject.next(value);

        if (value && value.length > 0) {
            if (value[0].Status.StatusCode == 1) {
                this.IsSuccess = true;
                this.ShowStatus = true;
            } else {
                this.IsSuccess = false;
                this.ShowStatus = true;
            }
        }
    }
    get merge(): Array<fromDataServices.Merge.Merge> {
        return this._merge;
    }

    constructor() {}

    ngOnInit(): void {
        this.types = [
            {
                label: 'Task',
                value: 'task'
            },
            {
                label: 'Service Item',
                value: 'serviceitem'
            }
        ];
    }

    onChangeType(event) {
        this.selectedType = event.value;
        if (event.value == 'task') {
            this.typeItems = this.tasks;
        } else {
            this.typeItems = this.serviceItems;
        }

        this.ShowStatus = false;
    }
    onChangeFrom(event) {
        this.selectedItemFrom = event.value;
        this.ShowStatus = false;
    }
    onChangeFinal(event) {
        this.selectedItemFinal = event.value;
        this.ShowStatus = false;
    }
    mergeClicked() {
        this.Merge.next({
            Mergetype: this.selectedType,
            Fromlistid: this.selectedItemFrom,
            Finallistid: this.selectedItemFinal
        });

        this.selectedType = null;
        this.selectedItemFrom = null;
        this.selectedItemFinal = null;
        this.areYouSure = false;
    }
}
